import React from 'react';
import styled from 'styled-components';

import {CalendarView} from '@stencil/dcalendar';

import {gaCheckinDateDifference, addDays} from '../../../../../shared/utils/date-utils';
import {maxAllowedRoomNights, defaultLengthOfStay} from '../../../../../shared/config/app-config';
import {HolidayCalendar} from '@stencil/holiday-calendar';

const CalendarBlock = React.forwardRef(
  (
    props: {
      isSearchWidget;
      isCheckinMode;
      isCheckoutMode;
      onSelection;
      updateQueryCaller;
      checkin;
      checkout;
      gaHandler;
    },
    ref,
  ) => {
    const {
      isSearchWidget,
      isCheckinMode,
      isCheckoutMode,
      onSelection,
      updateQueryCaller,
      checkin,
      checkout,
      gaHandler,
    } = props;

    const getClassName = (dateObj: Date, checkin?: Date, checkout?: Date) => {
      if (
        checkin &&
        dateObj.getMonth() === checkin.getMonth() &&
        dateObj.getDate() === checkin.getDate() &&
        dateObj.getFullYear() === checkin.getFullYear()
      ) {
        return 'leftactive';
      }
      if (
        checkout &&
        dateObj.getMonth() === checkout.getMonth() &&
        dateObj.getDate() === checkout.getDate() &&
        dateObj.getFullYear() === checkout.getFullYear()
      )
        return 'rightactive';
      if (
        checkin &&
        checkout &&
        dateObj.getTime() > checkin.getTime() &&
        dateObj.getTime() < checkout.getTime()
      )
        return 'partial';
      return '';
    };

    const dateOnClickHandler = dateObj => {
      if (isCheckinMode) {
        updateQueryCaller({
          checkin: {...checkin, date: dateObj},
          checkout: {...checkout, date: addDays(dateObj, defaultLengthOfStay)},
        });
        onSelection();
        gaHandler('calendarClicked', gaCheckinDateDifference(checkin));
      } else {
        updateQueryCaller({
          checkout: {...checkout, date: dateObj},
        });
        onSelection();
      }
    };

    const todaysDate = new Date();

    const maxDateAllowed = new Date();
    maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 12);
    if (isCheckoutMode) {
      maxDateAllowed.setDate(maxDateAllowed.getDate() + maxAllowedRoomNights);
    }

    return (
      <CalendarBlockOuterWrapper ref={ref} isSearchWidget={isSearchWidget}>
        <CalendarView
          dateConfigForMonthToBeDisplayed={isCheckinMode ? checkin.date : checkout.date}
          minDateAllowed={todaysDate}
          maxDateAllowed={maxDateAllowed}
          extendedComponent={HolidayCalendar}
          renderDateItem={({value, dateObj}) => {
            if (!value) {
              return (
                <li>
                  <span></span>
                </li>
              );
            }

            let isValid = true;

            dateObj.setHours(0, 0, 0, 0);

            if (isCheckinMode) {
              todaysDate.setHours(0, 0, 0, 0);
              isValid =
                dateObj.getTime() >= todaysDate.getTime() &&
                dateObj.getTime() < maxDateAllowed.getTime();
            }

            if (isCheckoutMode) {
              checkin.date.setHours(0, 0, 0, 0);
              const checkinLimit = addDays(checkin.date, 20);
              isValid =
                checkin.date.getTime() <= dateObj.getTime() &&
                dateObj.getTime() < checkinLimit.getTime();
            }

            return (
              <li
                style={isValid ? {color: 'black'} : {opacity: '0.4', color: 'grey'}}
                onClick={() => {
                  isValid ? dateOnClickHandler(dateObj) : () => {};
                }}
                isValid={isValid}
              >
                <span className={getClassName(dateObj, checkin.date, checkout.date)}>{value}</span>
              </li>
            );
          }}
        />
      </CalendarBlockOuterWrapper>
    );
  },
);

export default CalendarBlock;

const CalendarBlockOuterWrapper = styled.div(
  props => `
    // width: 37.5rem;
    display: flex;
    // flex-direction: column;
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: ${props.isSearchWidget ? '6.5rem' : '8rem'};
    // left: 0;
    z-index: ${props.theme.misc.zIndex.xlarge};
    border-radius: 1.2rem;
  `,
);
